import type { CosmicProductType } from '@/lib/cms/cosmic/types/CosmicProductType'

type Props = {
  productData: CosmicProductType
}

// This function checks if the product is a service product
// Service products are products that are not shipped, such as services or digital products
// It checks if the product belongs to the 'service' or 'services' category

export const isServiceProduct = ({ productData }: Props) =>
  productData.categories?.some(
    (category) => category.slug === 'service' || category.slug === 'services',
  )
